<template>
  <div class="attr-list">
    <el-form>
      <el-form-item label="主标题字体">
        <el-input-number v-model="curComponent.style.titleFontSize" />
      </el-form-item>
      <el-form-item label="副标题字体">
        <el-input-number v-model="curComponent.style.subTitleFontSize" />
      </el-form-item>
      <el-form-item label="内容字体">
        <el-input-number v-model="curComponent.style.fontSize" />
      </el-form-item>
      <el-form-item label="字体颜色">
        <el-color-picker v-model="curComponent.style.color" />
      </el-form-item>
      <el-form-item label="背景颜色">
        <el-color-picker v-model="curComponent.style.background" show-alpha />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>

export default {
  components: { },
  computed: {
    curComponent() {
      return this.$store.state.compose.curComponent
    }
  }
}
</script>
